import moment from 'moment';

export const EMPTY_ANALYTICS_DATA = {
  visits: 0,
  uniqueVisitors: 0,
  visitsCharts: [],
  uniqueVisitorsCharts: [],
  tableRows: [{ page: 'checkout-page' }],
};

export const getLatestByDate = (items = []) => {
  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  return [...items].sort((a, b) => moment(a.date).diff(moment(b.date))).at(-1);
};

export const formatDuration = (seconds) => {
  if (seconds == null || Number.isNaN(Number(seconds))) {
    return '00:00:00';
  }

  return moment.utc(moment.duration(Number(seconds), 'seconds').asMilliseconds()).format('HH:mm:ss');
};

export const sumByKey = (items = [], key) => {
  if (!Array.isArray(items)) {
    return 0;
  }

  return items.reduce((total, item) => total + (Number(item?.[key]) || 0), 0);
};
